import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import Routes from "./Routes";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Routes />
    </HelmetProvider>
  );
};

export default App;